import About from "../components/Home/About";
import BackgroundImage from "../components/Home/Background";
import EventFeatures from "../components/Home/EventFeatures";
import MiniBanner from "../components/Home/Minibanners";
import PopularEvents from "../components/Home/PopularEvents";
import CreateEvent from "../components/Home/CreateEvent";
import Quote from "../components/Home/Quote";
import Stats from "../components/Home/Stats";

const Home = () => {
  return (
    <>
      <BackgroundImage />
      <MiniBanner />
      <About/>
      <EventFeatures/>
      <Quote/>
      <PopularEvents/>
      <Stats/>
      <CreateEvent />
    </>
  );
};

export default Home;
